export default __webpack_public_path__ + "static/media/M4 - Arctic Cobra.0020124d.png";